import React, { useState } from 'react';
import BRAND_COLORS from './brandColors.js';

// Empty Cart Illustration
export const EmptyCartIllustration = () => (
  <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Shopping bag */}
    <path d="M60 80 L60 170 C60 175 65 180 70 180 L130 180 C135 180 140 175 140 170 L140 80"
          stroke="BRAND_COLORS.teal" strokeWidth="4" fill="none" strokeLinecap="round"/>
    <path d="M50 80 L150 80" stroke="BRAND_COLORS.teal" strokeWidth="4" strokeLinecap="round"/>

    {/* Bag handles */}
    <path d="M75 80 C75 60 85 45 100 45 C115 45 125 60 125 80"
          stroke="BRAND_COLORS.teal" strokeWidth="4" fill="none" strokeLinecap="round"/>

    {/* Sad face on bag */}
    <circle cx="85" cy="120" r="4" fill="BRAND_COLORS.fog"/>
    <circle cx="115" cy="120" r="4" fill="BRAND_COLORS.fog"/>
    <path d="M85 145 Q100 135 115 145" stroke="BRAND_COLORS.fog" strokeWidth="3" fill="none" strokeLinecap="round"/>

    {/* Floating sparkles */}
    <circle cx="40" cy="60" r="3" fill="BRAND_COLORS.poppy" opacity="0.6"/>
    <circle cx="160" cy="70" r="4" fill="BRAND_COLORS.goji" opacity="0.6"/>
    <circle cx="45" cy="140" r="3" fill="BRAND_COLORS.teal" opacity="0.6"/>
    <circle cx="155" cy="130" r="3" fill="BRAND_COLORS.poppy" opacity="0.6"/>
  </svg>
);

// No Restaurants Illustration
export const NoRestaurantsIllustration = () => (
  <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Plate */}
    <ellipse cx="100" cy="120" rx="70" ry="15" fill="BRAND_COLORS.fog" opacity="0.3"/>
    <circle cx="100" cy="110" r="60" stroke="BRAND_COLORS.teal" strokeWidth="4" fill="white"/>
    <circle cx="100" cy="110" r="50" stroke="BRAND_COLORS.teal" strokeWidth="2" fill="none"/>

    {/* Fork */}
    <path d="M60 60 L60 100" stroke="BRAND_COLORS.fog" strokeWidth="4" strokeLinecap="round"/>
    <path d="M54 60 L54 85" stroke="BRAND_COLORS.fog" strokeWidth="3" strokeLinecap="round"/>
    <path d="M66 60 L66 85" stroke="BRAND_COLORS.fog" strokeWidth="3" strokeLinecap="round"/>

    {/* Knife */}
    <path d="M140 60 L140 100" stroke="BRAND_COLORS.goji" strokeWidth="4" strokeLinecap="round"/>
    <path d="M135 60 L145 60 L145 70 L135 70 Z" fill="BRAND_COLORS.goji"/>

    {/* Question mark on plate */}
    <path d="M100 85 Q100 80 105 80 Q110 80 110 85 Q110 90 100 95"
          stroke="BRAND_COLORS.teal" strokeWidth="3" fill="none" strokeLinecap="round"/>
    <circle cx="100" cy="105" r="3" fill="BRAND_COLORS.teal"/>

    {/* Decorative elements */}
    <circle cx="30" cy="50" r="4" fill="BRAND_COLORS.poppy" opacity="0.6"/>
    <circle cx="170" cy="60" r="5" fill="BRAND_COLORS.goji" opacity="0.6"/>
    <circle cx="35" cy="140" r="3" fill="BRAND_COLORS.teal" opacity="0.6"/>
    <circle cx="165" cy="135" r="4" fill="BRAND_COLORS.poppy" opacity="0.6"/>
  </svg>
);

// No Active Orders Illustration
export const NoActiveOrdersIllustration = () => (
  <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Clipboard */}
    <rect x="60" y="40" width="80" height="120" rx="8" fill="white" stroke="BRAND_COLORS.teal" strokeWidth="4"/>
    <rect x="85" y="30" width="30" height="15" rx="4" fill="BRAND_COLORS.fog"/>

    {/* Checkmark lines (empty) */}
    <path d="M75 70 L125 70" stroke="#E5E7EB" strokeWidth="4" strokeLinecap="round"/>
    <path d="M75 90 L125 90" stroke="#E5E7EB" strokeWidth="4" strokeLinecap="round"/>
    <path d="M75 110 L125 110" stroke="#E5E7EB" strokeWidth="4" strokeLinecap="round"/>
    <path d="M75 130 L125 130" stroke="#E5E7EB" strokeWidth="4" strokeLinecap="round"/>

    {/* Happy checkmark */}
    <path d="M80 90 L90 100 L110 75" stroke="BRAND_COLORS.teal" strokeWidth="4" fill="none"
          strokeLinecap="round" strokeLinejoin="round" opacity="0.5"/>

    {/* Decorative elements */}
    <circle cx="40" cy="60" r="4" fill="BRAND_COLORS.poppy" opacity="0.6"/>
    <circle cx="160" cy="70" r="5" fill="BRAND_COLORS.goji" opacity="0.6"/>
    <circle cx="45" cy="150" r="3" fill="BRAND_COLORS.teal" opacity="0.6"/>
    <circle cx="155" cy="140" r="4" fill="BRAND_COLORS.poppy" opacity="0.6"/>
  </svg>
);

// Loading/Searching Illustration
export const SearchingIllustration = () => (
  <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Magnifying glass */}
    <circle cx="80" cy="80" r="35" stroke="BRAND_COLORS.teal" strokeWidth="4" fill="white"/>
    <path d="M107 107 L135 135" stroke="BRAND_COLORS.teal" strokeWidth="4" strokeLinecap="round"/>

    {/* Search sparkles */}
    <circle cx="80" cy="80" r="20" stroke="BRAND_COLORS.fog" strokeWidth="2"
            fill="none" strokeDasharray="4 4">
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 80 80"
        to="360 80 80"
        dur="3s"
        repeatCount="indefinite"
      />
    </circle>

    {/* Floating food icons */}
    <text x="140" y="50" fontSize="24" opacity="0.6">🍕</text>
    <text x="45" y="140" fontSize="24" opacity="0.6">🍜</text>
    <text x="150" y="130" fontSize="24" opacity="0.6">🌮</text>

    {/* Decorative dots */}
    <circle cx="40" cy="60" r="3" fill="BRAND_COLORS.poppy" opacity="0.6"/>
    <circle cx="160" cy="80" r="4" fill="BRAND_COLORS.goji" opacity="0.6"/>
  </svg>
);

// Image with shimmer placeholder + fade-in + graceful error fallback. Wraps the
// real <img> so the user sees a shimmering surface (not a white flash) while the
// network fetches, the image fades in when ready, and a teal-tinted fork-and-knife
// fallback shows if the load fails. Default fallback is "🍴" sized via fallbackTextClass.
//
// The image element itself is mounted once; we toggle classes/state rather than
// remounting, so the load handler fires reliably and the parent's other state
// updates don't reset the loaded/error flags.
export const ShimmerImage = ({
  src,
  alt,
  className = '',
  fallbackTextClass = 'text-3xl',
  fallbackEmoji = '🍴',
  loading = 'lazy',
}) => {
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);

  if (!src || errored) {
    return (
      <div
        className={`flex items-center justify-center bg-gradient-to-br from-teal/20 to-fog/40 ${className}`}
        role="img"
        aria-label={alt}
      >
        <span className={fallbackTextClass} aria-hidden="true">{fallbackEmoji}</span>
      </div>
    );
  }

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {!loaded && <div className="absolute inset-0 shimmer" />}
      <img
        src={src}
        alt={alt}
        loading={loading}
        onLoad={() => setLoaded(true)}
        onError={() => setErrored(true)}
        className={`w-full h-full object-cover transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`}
      />
    </div>
  );
};

// Skeleton placeholder for a restaurant card on the Home grid. Matches the real
// card layout (square logo block on the start side, three text lines on the end
// side) so when real cards swap in, layout stays put.
export const SkeletonRestaurantCard = () => (
  <div className="bg-white rounded-card shadow-elevation-1 overflow-hidden">
    <div className="flex items-start gap-3 p-4">
      <div className="w-16 h-16 flex-shrink-0 rounded-lg shimmer" />
      <div className="flex-1 space-y-2 pt-1">
        <div className="h-4 w-3/4 rounded-chip shimmer" />
        <div className="h-3 w-1/2 rounded-chip shimmer" />
        <div className="h-3 w-2/3 rounded-chip shimmer" />
      </div>
    </div>
  </div>
);

// Skeleton placeholder for an order card on the Orders list. Matches the
// header-row + meta-lines structure of the real card.
export const SkeletonOrderCard = () => (
  <div className="bg-white rounded-card shadow-elevation-1 p-5 space-y-3">
    <div className="flex justify-between">
      <div className="h-5 w-1/3 rounded-chip shimmer" />
      <div className="h-5 w-1/4 rounded-chip shimmer" />
    </div>
    <div className="h-3 w-1/2 rounded-chip shimmer" />
    <div className="h-3 w-full rounded-chip shimmer" />
  </div>
);

// Empty State Component — centers its content vertically in the available
// space (rather than anchoring to the top with fixed padding) so the title +
// message read as centered on mobile screens. The illustration is also scaled
// down on mobile so it doesn't eat half the screen above the text.
export const EmptyState = ({
  illustration,
  title,
  message,
  actionButton,
  className = ""
}) => (
  <div
    className={`text-center fade-in flex flex-col items-center justify-center min-h-[60vh] sm:min-h-0 px-6 py-8 sm:py-16 ${className}`}
  >
    {/* Scale down the SVG illustration on mobile via descendant selector
        (the SVGs have explicit width/height attrs, so we override w-* + h-auto). */}
    <div className="mb-5 sm:mb-6 flex justify-center [&_svg]:w-32 [&_svg]:h-32 sm:[&_svg]:w-48 sm:[&_svg]:h-48">
      {illustration}
    </div>
    <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2 sm:mb-3">{title}</h3>
    <p className="text-gray-600 text-base sm:text-lg mb-5 sm:mb-6 max-w-md mx-auto leading-relaxed">{message}</p>
    {actionButton && (
      <div className="mt-4 sm:mt-6">
        {actionButton}
      </div>
    )}
  </div>
);
